import classNames from 'classnames';

import { ButtonType } from '../../types/enums';

import styles from './Button.module.scss';

export interface ButtonProps {
  type: ButtonType;
  children: React.ReactNode;
  spaceSaving?: boolean;
  isSubmit?: boolean;
  fullWidth?: boolean;
  small?: boolean;
  action?: (event: React.MouseEvent) => void;
  disabled?: boolean;
}

const Button = ({
  children,
  type,
  isSubmit = false,
  fullWidth = false,
  spaceSaving = false,
  small = false,
  disabled = false,
  action = () => {}
}: ButtonProps) => {
  const classes = classNames(
    {
      [styles.fullWidth]: fullWidth
    },
    [styleMapping[type]],
    [styles.base],
    { [styles.slim]: spaceSaving },
    { [styles.small]: small }
  );

  return (
    <button
      onClick={action}
      disabled={disabled}
      type={isSubmit ? 'submit' : undefined}
      className={classes}>
      {children}
    </button>
  );
};

const styleMapping = {
  [ButtonType.PRIMARY]: styles.primary,
  [ButtonType.SECONDARY]: styles.secondary,
  [ButtonType.GHOST]: styles.ghost,
  [ButtonType.PRIMARY_INVERSE]: styles.primaryInverse
};

export default Button;
